import { History } from "history";

import {
  CreateQuestionRequest,
  QuestionDto,
  UpdateQuestionRequest,
} from "../../interfaces";
import {
  DELETE_QUESTION,
  DELETE_QUESTION_CONSENT,
  DELETE_QUESTION_ERROR,
  DELETE_QUESTION_SUCCESS,
  TOGGLE_ADD_EDIT_QUESTION_MODAL,
  TOGGLE_QUESTION_STATE,
  TOGGLE_QUESTION_STATE_CONSENT,
  TOGGLE_QUESTION_STATE_ERROR,
  TOGGLE_QUESTION_STATE_SUCCESS,
  ToggleAddEditQuestionModalAction,
  ToggleQuestionStateAction,
  ToggleQuestionStateConsentAction,
  ToggleQuestionStateErrorAction,
  ToggleQuestionStateSuccessAction,
  UPDATE_QUESTION,
  UPDATE_QUESTION_ERROR,
  UPDATE_QUESTION_SUCCESS,
  UPLOAD_QUESTION_DISPLAY_IMAGE,
  UPLOAD_QUESTION_DISPLAY_IMAGE_ERROR,
  UPLOAD_QUESTION_DISPLAY_IMAGE_SUCCESS,
  UPLOAD_QUESTION_IMAGE,
  UPLOAD_QUESTION_IMAGE_ERROR,
  UPLOAD_QUESTION_IMAGE_SUCCESS,
  UploadQuestionDisplayImageAction,
  UploadQuestionDisplayImageErrorAction,
  UploadQuestionDisplayImageSuccessAction,
  UploadQuestionImageAction,
  UploadQuestionImageErrorAction,
  UploadQuestionImageSuccessAction,
} from "../question/actionTypes";
import {
  GetQuestionsByLessonAction,
  GET_QUESTIONS_BY_LESSON,
  GetQuestionsByLessonSuccessAction,
  GET_QUESTIONS_BY_LESSON_SUCCESS,
  GetQuestionsByLessonErrorAction,
  GET_QUESTIONS_BY_LESSON_ERROR,
  AddQuestionAction,
  AddQuestionErrorAction,
  AddQuestionSuccessAction,
  DeleteQuestionAction,
  DeleteQuestionConsentAction,
  DeleteQuestionErrorAction,
  DeleteQuestionSuccessAction,
  GetQuestionAction,
  GetQuestionErrorAction,
  GetQuestionSuccessAction,
  UpdateQuestionAction,
  UpdateQuestionErrorAction,
  UpdateQuestionSuccessAction,
  GET_QUESTION,
  ADD_QUESTION,
  ADD_QUESTION_ERROR,
  ADD_QUESTION_SUCCESS,
  GET_QUESTION_ERROR,
  GET_QUESTION_SUCCESS,
} from "./actionTypes";
import { MediaDto } from "../../interfaces/media";
import { QuestionModelEnum } from "../../enums";

//#region Get Questions by Grade

export const getQuestionsByLesson = (
  lessonId: string,
  model?: QuestionModelEnum
): GetQuestionsByLessonAction => {
  return {
    type: GET_QUESTIONS_BY_LESSON,
    payload: { lessonId, model },
  };
};

export const getQuestionsByLessonSuccess = (
  response: QuestionDto[]
): GetQuestionsByLessonSuccessAction => {
  return {
    type: GET_QUESTIONS_BY_LESSON_SUCCESS,
    payload: response,
  };
};

export const getQuestionsByLessonError = (
  error: any
): GetQuestionsByLessonErrorAction => {
  return {
    type: GET_QUESTIONS_BY_LESSON_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Question

export const getQuestion = (
  id: string,
  history: History
): GetQuestionAction => {
  return {
    type: GET_QUESTION,
    payload: { id, history },
  };
};

export const getQuestionSuccess = (
  response: QuestionDto
): GetQuestionSuccessAction => {
  return {
    type: GET_QUESTION_SUCCESS,
    payload: response,
  };
};

export const getQuestionError = (error: any): GetQuestionErrorAction => {
  return {
    type: GET_QUESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Question

export const addQuestion = (
  request: any,
  history: History
): AddQuestionAction => {
  return {
    type: ADD_QUESTION,
    payload: { request, history },
  };
};

export const addQuestionSuccess = (): AddQuestionSuccessAction => {
  return {
    type: ADD_QUESTION_SUCCESS,
    payload: null,
  };
};

export const addQuestionError = (error: any): AddQuestionErrorAction => {
  return {
    type: ADD_QUESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Question

export const updateQuestion = (
  id: string,
  request: any,
  history: History
): UpdateQuestionAction => {
  return {
    type: UPDATE_QUESTION,
    payload: { id, request, history },
  };
};

export const updateQuestionSuccess = (): UpdateQuestionSuccessAction => {
  return {
    type: UPDATE_QUESTION_SUCCESS,
    payload: null,
  };
};

export const updateQuestionError = (error: any): UpdateQuestionErrorAction => {
  return {
    type: UPDATE_QUESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Question

export const deleteQuestionConsent = (
  id: string
): DeleteQuestionConsentAction => {
  return {
    type: DELETE_QUESTION_CONSENT,
    payload: id,
  };
};

export const deleteQuestion = (
  id: string,
  history: History
): DeleteQuestionAction => {
  return {
    type: DELETE_QUESTION,
    payload: { id, history },
  };
};

export const deleteQuestionSuccess = (): DeleteQuestionSuccessAction => {
  return {
    type: DELETE_QUESTION_SUCCESS,
    payload: null,
  };
};

export const deleteQuestionError = (error: any): DeleteQuestionErrorAction => {
  return {
    type: DELETE_QUESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Question Home Image

export const uploadQuestionDisplayImage = (
  file: File,
  history: History,
  questionId?: string
): UploadQuestionDisplayImageAction => {
  return {
    type: UPLOAD_QUESTION_DISPLAY_IMAGE,
    payload: { file, history, questionId },
  };
};

export const uploadQuestionDisplayImageSuccess = (
  media: MediaDto
): UploadQuestionDisplayImageSuccessAction => {
  return {
    type: UPLOAD_QUESTION_DISPLAY_IMAGE_SUCCESS,
    payload: media,
  };
};

export const uploadQuestionDisplayImageError = (
  error: any
): UploadQuestionDisplayImageErrorAction => {
  return {
    type: UPLOAD_QUESTION_DISPLAY_IMAGE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Question Image

export const uploadQuestionImage = (
  file: File,
  history: History,
  tempId: string
): UploadQuestionImageAction => {
  return {
    type: UPLOAD_QUESTION_IMAGE,
    payload: { file, history, tempId },
  };
};

export const uploadQuestionImageSuccess = (data: {
  id: string;
  url: string;
  tempId: number;
}): UploadQuestionImageSuccessAction => {
  return {
    type: UPLOAD_QUESTION_IMAGE_SUCCESS,
    payload: data,
  };
};

export const uploadQuestionImageError = (
  error: any
): UploadQuestionImageErrorAction => {
  return {
    type: UPLOAD_QUESTION_IMAGE_ERROR,
    payload: error,
  };
};

//#endregion

//#region add edit question modal
export const toggleAddEditQuestionModal =
  (): ToggleAddEditQuestionModalAction => {
    return {
      type: TOGGLE_ADD_EDIT_QUESTION_MODAL,
      payload: null,
    };
  };
//#endregion

//#region Toggle Question State

export const toggleQuestionStateConsent = (
  id: string
): ToggleQuestionStateConsentAction => {
  return {
    type: TOGGLE_QUESTION_STATE_CONSENT,
    payload: id,
  };
};

export const toggleQuestionState = (
  id: string,
  history: History
): ToggleQuestionStateAction => {
  return {
    type: TOGGLE_QUESTION_STATE,
    payload: { id, history },
  };
};

export const toggleQuestionStateSuccess = (
  id: string
): ToggleQuestionStateSuccessAction => {
  return {
    type: TOGGLE_QUESTION_STATE_SUCCESS,
    payload: { id },
  };
};

export const toggleQuestionStateError = (
  error: any
): ToggleQuestionStateErrorAction => {
  return {
    type: TOGGLE_QUESTION_STATE_ERROR,
    payload: error,
  };
};

//#endregion
